import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton, Box, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import FeedbackIcon from '@mui/icons-material/Feedback';

const Sidebar = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (isOpen) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpen(isOpen);
  };

  const menuItems = [
    { text: '首页', icon: <HomeIcon sx={{ color: '#4caf50' }} />, path: '/' },
    { text: '龙虎榜', icon: <ShowChartIcon sx={{ color: '#2196f3' }} />, path: '/longhubang' },
    { text: '交易小工具', icon: <BuildIcon sx={{ color: '#ff9800' }} />, path: '/tools' },
    { text: '用户反馈', icon: <FeedbackIcon sx={{ color: '#9c27b0' }} />, path: '/feedback' },
    { text: '捐助支持', icon: <VolunteerActivismIcon sx={{ color: '#f44336' }} />, path: '/donate' },
  ];

  return (
    <>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={toggleDrawer(true)}
        sx={{ 
          mr: 2,
          borderRadius: '12px',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            background: 'rgba(255, 255, 255, 0.2)',
            transform: 'scale(1.1) rotate(90deg)',
            boxShadow: '0 4px 15px rgba(255, 255, 255, 0.3)',
          },
          '&:active': {
            transform: 'scale(0.95) rotate(90deg)',
          }
        }}
      >
        <MenuIcon sx={{ 
          color: '#ffffff',
          transition: 'all 0.3s ease',
          fontSize: '1.5rem'
        }} />
      </IconButton>
      
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            borderRadius: 0,
            background: 'linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%)',
            boxShadow: '4px 0 20px rgba(0, 0, 0, 0.15)',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(2px)',
          }
        }}
        transitionDuration={{
          enter: 300,
          exit: 250
        }}
      >
        <Box
          sx={{ 
            width: 250,
            height: '100%',
            background: 'transparent',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '60px',
              background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
              zIndex: 0,
            }
          }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List sx={{ pt: 8, position: 'relative', zIndex: 1 }}>
            {menuItems.map((item, index) => (
              <ListItem 
                button 
                key={item.text} 
                component={Link} 
                to={item.path}
                sx={{
                  mx: 1,
                  my: 0.5,
                  borderRadius: '12px',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: `translateX(${open ? '0' : '-20px'})`,
                  opacity: open ? 1 : 0,
                  transitionDelay: `${index * 50}ms`,
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.1)',
                    transform: 'translateX(8px) scale(1.02)',
                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
                  },
                  '&:active': {
                    transform: 'translateX(8px) scale(0.98)',
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    color: '#1976d2',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'rotate(10deg) scale(1.1)',
                    }
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={item.text} 
                  sx={{
                    '& .MuiListItemText-primary': {
                      fontWeight: 500,
                      color: '#333',
                      transition: 'all 0.3s ease',
                    }
                  }}
                />
              </ListItem>
            ))}
          </List>
          <Divider 
            sx={{ 
              mx: 2, 
              background: 'linear-gradient(90deg, transparent, #1976d2, transparent)',
              height: '2px',
              border: 'none'
            }} 
          />
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;